import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { PlanStatsList } from '../PlanStatsList';
import styles from './PlanLoaderProgress.css';

const RADIUS = 50;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const DEFAULT_STEPS = ['Reading your answers', 'Preparing her first chapter', 'Writing her letter', 'First question ready'];

function PlanLoaderProgress({ finish, steps = DEFAULT_STEPS, stats }) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (progress === 100) {
            finish();

            return;
        }

        const timer = setTimeout(() => setProgress(prev => prev + 1), 100);

        return () => clearTimeout(timer);
    }, [progress]);

    const strokeDashoffset = CIRCUMFERENCE - (progress / 100) * CIRCUMFERENCE;
    const stepSize = 100 / steps.length;

    const getStepPercent = index => {
        const min = index * stepSize;
        const max = (index + 1) * stepSize;

        if (progress <= min) return 0;
        if (progress >= max) return 100;

        return Math.round((progress - min) / (max - min) * 100);
    };

    return (
        <div className={styles.root}>
            <div className={styles.progressContainer} role='progressbar' aria-valuenow={progress}>
                <svg width='112' height='112' aria-hidden='true'>
                    <circle
                        cx='56' cy='56' r={RADIUS}
                        className={styles.circleBg}
                    />
                    <circle
                        cx='56' cy='56' r={RADIUS}
                        className={styles.circle}
                        style={{ strokeDashoffset }}
                    />
                </svg>
                <p className={styles.progressText}>{progress}%</p>
            </div>
            <h1 className={styles.title}>Almost there</h1>
            <div className={styles.steps}>
                {steps.map((step, index) => {
                    const pct = getStepPercent(index);

                    return (
                        <div className={styles.progressBar} key={step}>
                            <div className={styles.progressBarContent}>
                                <span>{step}</span>
                                <span>{pct}%</span>
                            </div>
                            <div className={styles.progressBarTrack}>
                                <div className={styles.progressBarFill} style={{ width: `${pct}%` }} />
                            </div>
                        </div>
                    );
                })}
            </div>
            <PlanStatsList stats={stats} />
        </div>
    );
}

PlanLoaderProgress.propTypes = {
    finish: PropTypes.func.isRequired,
    steps: PropTypes.arrayOf(PropTypes.string),
    stats: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        percent: PropTypes.string,
        description: PropTypes.node,
        highlight: PropTypes.node
    }))
};

export {
    PlanLoaderProgress
};
